import { createTheme } from "@mui/material/styles";
import { getScrollbarStyleOverrides } from "./scrollbarStyles";

const theme = createTheme({
  direction: "ltr",
  typography: {
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  palette: {
    mode: "dark",
    background: {
      default: "#2f2f2f",
      paper: "#171717",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255,255,255,0.72)",
    },
    primary: {
      light: "#F4B752",
      main: "#E8A33D",
      dark: "#B97A1F",
      contrastText: "#0B0D0F",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: getScrollbarStyleOverrides(),
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "1px solid rgba(255,255,255,0.08)",
          backgroundColor: "#0b0b0b",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255,255,255,0.03)",
          borderRadius: 4,
        },
        notchedOutline: {
          borderColor: "rgba(255,255,255,0.14)",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "rgba(255,255,255,0.7)",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "rgba(255,255,255,0.6)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 4,
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
